require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-national-credit-union-foundation.json") })
        }
      }, "path---articles-tags-national-credit-union-foundation");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-national-credit-union-foundation!./.cache/json/articles-tags-national-credit-union-foundation.json
// module id = 1899
// module chunks = 231608221292675